import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'Kit de Emergencia para la Primera Toma',
  desc: 'Protocolo SOS de 5 min + secuencia del agarre + test de 30 seg',
  value: '$15.000'
}, {
  num: '02',
  title: 'Checklist de Agarre Perfecto en 60 Segundos',
  desc: '7 señales verdes + 7 alertas + método Mirá-Sentí-Escuchá',
  value: '$12.000'
}, {
  num: '03',
  title: 'Menú Express para Mamás Sin Tiempo',
  desc: 'Desayunos de 5 min + menú semanal + lista de compras + printable heladera',
  value: '$10.000'
}, {
  num: '04',
  title: 'Guía de Mitos de Lactancia',
  desc: '35 mitos desmontados + filtro mental + scripts para el entorno',
  value: '$12.000'
}, {
  num: '05',
  title: 'Planilla de Tomas, Pañales y Progreso',
  desc: 'Tracker 7 días + semáforo de indicadores + hoja para el pediatra',
  value: '$10.000'
}, {
  num: '06',
  title: 'Mini Guía de Calma para Mamás por Colapsar',
  desc: 'Protocolo 3 min + frases reales + rutina anti-colapso 3 AM',
  value: '$12.000'
}];
export function Bonuses() {
  return <section className="py-16 md:py-20 px-4 bg-brand-cream" data-id="element-51" data-mp="3r6qgkhts46gi">
      <div className="max-w-5xl mx-auto" data-id="element-52" data-mp="3r5ymjbftygsc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-53" data-mp="3n5etaiydnxbh">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-darker inline-flex items-center justify-center gap-4" data-id="element-54" data-mp="38g8vmzf6uf5p">
            <Gift className="w-10 h-10 text-brand-accent" data-id="element-55" data-mp="33gns0bp2pimn" />6 BONOS — SIEMPRE
            INCLUIDOS
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-56" data-mp="noghtcvctpw5">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col md:flex-row items-start md:items-center gap-4 bg-brand-cream-light p-6 rounded-3xl border border-brand-primary/35 shadow-sm" data-id="element-57" data-mp="ipwvvcgrge3s" data-mpi={i}>
              <div className="flex items-center gap-4 w-full md:w-auto md:min-w-[120px]" data-id="element-58" data-mp="2xtqtx79qm3dw">
                <span className="text-3xl font-serif text-brand-accent/70 font-bold" data-id="element-59" data-mp="32t3hxvcchgi2">
                  #{bono.num}
                </span>
                <Gift className="w-6 h-6 text-brand-gold hidden md:block" data-id="element-60" data-mp="37kv7q3nofi75" />
              </div>

              <div className="flex-1" data-id="element-61" data-mp="2a3ee7a8932cr">
                <h4 className="text-xl font-bold text-brand-darker mb-1" data-id="element-62" data-mp="2a2d2r4nbodui">
                  {bono.title}
                </h4>
                <p className="text-brand-darker/70" data-id="element-63" data-mp="27jzxnq32y3be">{bono.desc}</p>
              </div>

              <div className="flex items-center gap-4 w-full md:w-auto justify-between md:justify-end mt-4 md:mt-0 pt-4 md:pt-0 border-t border-brand-primary/20 md:border-t-0" data-id="element-64" data-mp="27hnfbbtetqxt">
                <span className="text-brand-darker/45 line-through text-lg" data-id="element-65" data-mp="1xk0nxpuxc6wy">
                  {bono.value}
                </span>
                <span className="bg-brand-accent text-brand-darker font-bold px-4 py-1 rounded-full text-sm" data-id="element-66" data-mp="1ol5iifzpf0up">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-brand-accent/15 border border-brand-accent/40 p-6 rounded-3xl" data-id="element-67" data-mp="1eukm8z7i68ey">
          <p className="text-2xl md:text-3xl font-serif text-brand-darker" data-id="element-68" data-mp="10xxavreszfpi">
            Valor total bonos:{' '}
            <span className="line-through text-brand-darker/45 mx-2" data-id="element-69" data-mp="34zea3clx9ml4">
              $71.000
            </span>
            <span className="text-brand-darker font-bold" data-id="element-70" data-mp="2r89b8cqdoybu">
              → GRATIS con tu Pack
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}